import { render, staticRenderFns } from "./OwnerActions.vue?vue&type=template&id=9164e212&scoped=true&"
import script from "./OwnerActions.vue?vue&type=script&lang=js&"
export * from "./OwnerActions.vue?vue&type=script&lang=js&"
import style0 from "./OwnerActions.vue?vue&type=style&index=0&id=9164e212&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9164e212",
  null
  
)

export default component.exports